import * as React from "react";
import * as Dati from "../Dati";
import * as Glob from "../Globale";
import * as DatiRCP from "../DatiRCP";
import { AccordionAnagrafica, AccordionCampiPolizza, AccordionGaranzie, AccordionProdotti, AddendumActions, BaseComponent, CampiPolizza, ChiamaAPI, InputData, Tipo, Trad } from "../components";

interface IRCPAppendiceState {
    AnagraficaJSON: Glob.DatiJSON;
    ChangedProduct: string;
    Dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore;
    DatiProfessionaliJSON: Glob.DatiJSON;
    DatoRCPPolizza: any;
    FormData: Dati.CAppendiceDati[];
    Frazionamento: number;
    GaranzieJSON: Glob.DatiJSON;
    IndirizziJSON: Glob.DatiJSON;
    PolizzeJSON: Glob.DatiJSON;
    RecapitiJSON: Glob.DatiJSON;
}

export class RCPAppendice extends BaseComponent<Glob.IRouteGlobaleProps, IRCPAppendiceState> {
    private ID_Polizza: number = 0;
    private ID_AnagContraente = 0;
    private ID_Appendice: number = 0;
    private _CalcolaPolizze: number = -1;
    private _Frazionamento: Dati.TDictTipo = {};
    private _Polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();

    constructor(props: any) {
        super(props);

        this.state = {
            AnagraficaJSON: "",
            ChangedProduct: "",
            Dati: new DatiRCP.CRisAPIDatoTipiInfo_Comparatore(),
            DatiProfessionaliJSON: "",
            DatoRCPPolizza: {},
            FormData: [],
            Frazionamento: 12,
            GaranzieJSON: "",
            IndirizziJSON: "",
            PolizzeJSON: "",
            RecapitiJSON: ""
        };
        this.AddProductAppendice = this.AddProductAppendice.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnChangeElement = this.OnChangeElement.bind(this);
        this.OnChangeGaranzia = this.OnChangeGaranzia.bind(this);
        this.OnChangeGaranziaElement = this.OnChangeGaranziaElement.bind(this);
        this.OnCreateAddendum = this.OnCreateAddendum.bind(this);
        this.OnInvioCalcola = this.OnInvioCalcola.bind(this);
        this.GetFieldDetails = this.GetFieldDetails.bind(this);
        this.PopolaFrazionamento();
    }

    private OnChangeElement(e: React.FormEvent<any> | string, v: any, label: string = "", fieldTypeId: number = 0, elementGroup?: any): any {
        const fieldId = typeof e == "string" ? e : e.currentTarget.id || e.currentTarget.name;
        const appendiceItem = {
            ID_Appendice: 0,
            ID_TipoCampo: fieldTypeId,
            Etichetta: label || fieldId,
            CampoAppendice: fieldId,
            ValoreAppendice: typeof e != "string" && v == undefined ? e.currentTarget.value : v,
            AppendiceGroup: elementGroup
        };
        let isChanged = false;

        let appendiceData = this.state.FormData.map(item => {
            if (item.CampoAppendice == fieldId) {
                isChanged = true;
                return appendiceItem;
            }
            return item;
        });

        if (!isChanged && fieldId !== "PreventivoSelezionato") {
            appendiceData.push(appendiceItem);
        } else {
            appendiceData = this.RemoveUnChangedFields(appendiceItem, appendiceData);
        }
        this.setState({ FormData: appendiceData });
    }

    private RemoveUnChangedFields(appendiceItem: any, appendiceData: any) {
        let currentItem: any;
        this.state.FormData.map(item => {
            if (appendiceItem.CampoAppendice === item.CampoAppendice) {
                currentItem = item;
            }
        });
        return appendiceData.filter((item: any) => {
            if (item.ID_TipoCampo == 13) {
                return JSON.parse(item.ValoreAppendice).RispostaAperturaQuestionario == JSON.parse(currentItem.ValoreAppendice).RispostaAperturaQuestionario;
            }

            return true;
        });
    }

    private OnChangeGaranziaElement(v: any) {
        this.setState({ ChangedProduct: v });
    }

    private AddProductAppendice() {
        if (this.state.ChangedProduct) {
            const changedProduct = JSON.parse(this.state.ChangedProduct);
            const { ID_TipoGaranzia, Selezionata } = changedProduct;
            const elementGroup: object[] = [];
            let tmpPolizze: DatiRCP.CProdotto[] = [];

            if (typeof this.state.PolizzeJSON == "string") {
                tmpPolizze = JSON.parse(this.state.PolizzeJSON);
            } else {
                tmpPolizze = this.state.PolizzeJSON;
            }

            elementGroup.push({
                ValoreAppendice: Selezionata,
                Etichetta: ID_TipoGaranzia,
                ID_TipoCampo: 5
            });

            tmpPolizze.forEach((polizze: any, index: number) => {
                if (polizze.GaranziaBase.Selezionata) {
                    polizze.GaranzieAccessorie.forEach((item: any, i: number) => {
                        if (item.ID_TipoGaranzia === ID_TipoGaranzia) {
                            item.Selezionata = Selezionata;
                            this.OnChangeElement(`Polizze[${index}].GaranzieAccessorie[${i}]`, JSON.stringify(item), ID_TipoGaranzia, 0, elementGroup);
                        }
                    });
                }
            });
        }
    }

    private GetFieldDetails(e: React.FormEvent<any> | string, v: any) {
        const id = typeof e == "string" ? e : e.currentTarget.id || e.currentTarget.name;
        let label = id.split(".")[1];
        let fieldTypeId = 0;
        const elementGroup = [];

        if (this.state.Dati.Info[label] && v && v.DatiQuestionario) {
            const structure = JSON.parse(this.state.Dati.Info[label].ParametriJSON).DatiQuestionario || [];

            for (var n = 0; n < v.DatiQuestionario.length; n++) {
                for (var i in v.DatiQuestionario[n].items) {
                    for (var x = 0; x < structure.length; x++) {
                        if (i === structure[x].Campo) {
                            elementGroup.push({
                                ValoreAppendice: v.DatiQuestionario[n].items[i],
                                Etichetta: structure[x].Etichetta,
                                ID_TipoCampo: structure[x].ID_TipoCampo
                            });
                        }
                    }
                }
            }
        }

        if (typeof v !== "string" && typeof v !== "boolean") {
            v = JSON.stringify(v);
        }

        for (var I in this.state.Dati.Info) {
            if (I === label) {
                label = this.state.Dati.Info[I].Etichetta;
                fieldTypeId = this.state.Dati.Info[I].ID_TipoCampo;
            }
        }

        return {
            value: v,
            label,
            fieldTypeId,
            elementGroup
        };
    }

    private PopolaFrazionamento() {
        this._Frazionamento = {};
        this._Frazionamento["1"] = new Dati.CTipo("4", "Quadrimestrale");
        this._Frazionamento["2"] = new Dati.CTipo("6", "Semestrale");
        this._Frazionamento["3"] = new Dati.CTipo("12", "Annuale");
    }

    private OnInvioCalcola(sender: ChiamaAPI): any {
        this._Polizze.Parametri = this.state.DatoRCPPolizza;
        this._Polizze.Parametri["Frazionamento"] = this.state.Frazionamento;
        return this._Polizze;
    }

    private OnRisCalcolaPolizze(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            dati.Garanzie = JSON.parse(this.state.GaranzieJSON);
            this.PopolaProdotti(dati, true);
        }
        return false;
    }

    private PopolaProdotti(dati: DatiRCP.CRisAPIRCPInfo, saveCastelletto?: boolean): void {
        let prodotti: DatiRCP.CProdotto[] = [];
        if (dati.Polizze != undefined) {
            for (let i: number = 0; i < dati.Polizze.length; i++) {
                //Selezaiono le polizze
                let prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                prodotto.ID_Binder = dati.Polizze[i].Dati[0].ID_Binder;
                prodotto.ID_BinderCompagnia = dati.Polizze[i].Dati[0].ID_BinderCompagnia;
                prodotto.ID_AnagCompagniaBinder = dati.Polizze[i].Dati[0].ID_AnagCompagniaBinder;
                prodotto.Compagnia = dati.Polizze[i].Dati[0].Compagnia; //Garanzia base
                prodotto.Logo = "";
                prodotto.LimiteAccessori = dati.Polizze[i].Dati[0].LimiteAccessori;
                prodotto.LimiteFlessibilita = dati.Polizze[i].Dati[0].LimiteFlessibilita;
                prodotto.Scoperto = dati.Polizze[i].Dati[0].Scoperto;
                prodotto.ScopertoMin = dati.Polizze[i].Dati[0].ScopertoMin;
                prodotto.ScopertoMax = dati.Polizze[i].Dati[0].ScopertoMax;

                prodotto.PremioNettoMaggiorato = dati.Polizze[i].Dati[0].PremioNettoMaggiorato;
                prodotto.Accessori = dati.Polizze[i].Dati[0].Accessori;
                prodotto.Flessibilita = dati.Polizze[i].Dati[0].Flessibilita;

                let garanzia: DatiRCP.CGaranzia = new DatiRCP.CGaranzia();
                garanzia.Abilitata = !dati.Polizze[i].Dati[0].Errore;
                if (dati.Polizze[i].Dati[0].Semaforo == DatiRCP.SemaforoRosso) {
                    garanzia.Abilitata = false;
                }
                garanzia.Semaforo = dati.Polizze[i].Dati[0].Semaforo;
                garanzia.Base = true;
                garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[0].ID_TipoGaranzia;
                garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[0].NomeClasseGaranzia;
                garanzia.ImportoLordo = dati.Polizze[i].Dati[0].ImportoLordo;
                garanzia.ImportoNetto = dati.Polizze[i].Dati[0].ImportoNetto;
                garanzia.Messaggio = dati.Polizze[i].Dati[0].Messaggio;
                garanzia.Dati = dati.Polizze[i].Dati[0].Dati;

                prodotto.GaranziaBase = garanzia;
                prodotto.GaranzieAccessorie = [];

                for (let x: number = 1; x < dati.Polizze[i].Dati.length; x++) {
                    //Garanzie accessorie per questo parto da 1
                    let garanzia: DatiRCP.CGaranzia = new DatiRCP.CGaranzia();
                    garanzia.Abilitata = !dati.Polizze[i].Dati[x].Errore;
                    if (dati.Polizze[i].Dati[x].Semaforo == DatiRCP.SemaforoRosso) {
                        garanzia.Abilitata = false;
                    }
                    garanzia.Semaforo = dati.Polizze[i].Dati[x].Semaforo;
                    garanzia.Base = false;
                    garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[x].ID_TipoGaranzia;
                    garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[x].NomeClasseGaranzia;
                    garanzia.ImportoLordo = dati.Polizze[i].Dati[x].ImportoLordo;
                    garanzia.ImportoNetto = dati.Polizze[i].Dati[x].ImportoNetto;
                    garanzia.Messaggio = dati.Polizze[i].Dati[x].Messaggio;
                    garanzia.Dati = dati.Polizze[i].Dati[x].Dati;
                    prodotto.GaranzieAccessorie.push(garanzia);
                }

                if (saveCastelletto) {
                    let tmpPolizze: DatiRCP.CProdotto[] = [];
                    if (typeof this.state.PolizzeJSON == "string") {
                        tmpPolizze = JSON.parse(this.state.PolizzeJSON);
                    } else {
                        tmpPolizze = this.state.PolizzeJSON;
                    }

                    let tmpPolizza: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                    tmpPolizza = tmpPolizze[tmpPolizze.findIndex(p => p.ID_BinderCompagnia == dati.Polizze[i].Dati[0].ID_BinderCompagnia)] || tmpPolizza;

                    if (
                        typeof tmpPolizza.CalcolaImportoNettoTotale == "function" &&
                        tmpPolizza.PremioNettoMaggiorato != tmpPolizza.CalcolaImportoNettoTotale() &&
                        tmpPolizza.PremioNettoMaggiorato > prodotto.CalcolaImportoNettoTotale()
                    )
                        //Lo tengo solo se era stato impostato dall'utente
                        prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;

                    prodotto.Accessori = tmpPolizza.Accessori;
                    prodotto.Flessibilita = tmpPolizza.Flessibilita;
                    prodotto.GaranziaBase.Selezionata = tmpPolizza.GaranziaBase.Selezionata;
                }

                prodotti.push(prodotto);
            }

            if (this._CalcolaPolizze < 0) {
                for (let i: number = 0; i < dati.Garanzie.length; i++) {
                    if (dati.Garanzie[i].ProprietaSelezione == "O" || dati.Garanzie[i].ProprietaSelezione == "P") {
                        dati.Garanzie[i].Selezionata = true;
                    }
                }
            }

            this.setState({ PolizzeJSON: JSON.stringify(prodotti) }, this.AddProductAppendice);
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                if (dati.ID_Chiave > 0) {
                    let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
                    DatiPolizza = JSON.parse(dati.Dato.DatiPolizza);
                    this.setState(
                        {
                            Dati: dati,
                            DatoRCPPolizza: DatiPolizza.DatoRCPPolizza,
                            PolizzeJSON: JSON.stringify(DatiPolizza.Polizze),
                            GaranzieJSON: JSON.stringify(DatiPolizza.Garanzie)
                        },
                        () => {
                            this.PopolaGaranzie(DatiPolizza.Garanzie);
                        }
                    );
                }
            } else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
        }
        return true;
    }

    private OnRisDatiPolizzaNuova(sender: ChiamaAPI, dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.Dati.Dato.ID_TipoProdotto) {
            let datiPolizzaVuota: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
            datiPolizzaVuota.Info = dati.Info;
            datiPolizzaVuota.Dato = this.state.Dati.Dato;
            let nuovaPolizza: any = Glob.CreaClassePolizzaRCP(dati.Info);
            this.setState({ Dati: datiPolizzaVuota, DatoRCPPolizza: nuovaPolizza });
        }
        return false;
    }

    private OnRisAnagrafica(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Anag, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && dati.Dato.ID_Anag > 0) {
            this.setState({
                AnagraficaJSON: JSON.stringify(dati.Dato),
                RecapitiJSON: dati.Dato.RecapitiJSON,
                IndirizziJSON: dati.Dato.IndirizziJSON,
                DatiProfessionaliJSON: dati.Dato.DatiProfessionaliJSON
            });
        }
        return false;
    }

    private OnChangeGaranzia(e: React.FormEvent<any> | string, valore?: any): void {
        let garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[];

        if (valore == undefined) {
            garanzieApp = JSON.parse(this.state.GaranzieJSON);
        } else {
            garanzieApp = JSON.parse(valore);
        }
        this.PopolaGaranzie(garanzieApp);

        if (valore != undefined) {
            this.OnChange(e, valore);
        }
    }

    private PopolaGaranzie(garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[], cb?: void) {
        this._Polizze = new DatiRCP.CRCPPolizze();
        let polizzeApp: DatiRCP.CProdotto[] = [];

        polizzeApp = typeof this.state.PolizzeJSON == "string" ? JSON.parse(this.state.PolizzeJSON) : this.state.PolizzeJSON;

        for (let i: number = 0; i < polizzeApp.length; i++) {
            let polizzaApp: DatiRCP.CRCPPolizza = new DatiRCP.CRCPPolizza();
            polizzaApp.ID_Binder = polizzeApp[i].ID_Binder;
            polizzaApp.ID_BinderCompagnia = polizzeApp[i].ID_BinderCompagnia;
            polizzaApp.ID_AnagCompagniaBinder = polizzeApp[i].ID_AnagCompagniaBinder;
            polizzaApp.Compagnia = polizzeApp[i].Compagnia;
            polizzaApp.ImportoLordo = polizzeApp[i].GaranziaBase.ImportoLordo;
            polizzaApp.ImportoNetto = polizzeApp[i].GaranziaBase.ImportoNetto;
            polizzaApp.ID_TipoGaranzia = polizzeApp[i].GaranziaBase.ID_TipoGaranzia;
            polizzaApp.NomeClasseGaranzia = polizzeApp[i].GaranziaBase.NomeClasseGaranzia;

            polizzaApp.LimiteAccessori = polizzeApp[i].LimiteAccessori;
            polizzaApp.LimiteFlessibilita = polizzeApp[i].LimiteFlessibilita;

            polizzaApp.Scoperto = polizzeApp[i].Scoperto;
            polizzaApp.ScopertoMin = polizzeApp[i].ScopertoMin;
            polizzaApp.ScopertoMax = polizzeApp[i].ScopertoMax;

            for (let x: number = 0; x < garanzieApp.length; x++) {
                if (garanzieApp[x].Selezionata) {
                    let garanziaApp: DatiRCP.CRCPGaranzia = new DatiRCP.CRCPGaranzia();
                    garanziaApp.ID_TipoGaranzia = garanzieApp[x].ID_TipoGaranzia;
                    garanziaApp.NomeClasseGaranzia = garanzieApp[x].NomeClasseGaranzia[polizzaApp.Compagnia];

                    polizzaApp.Garanzie.push(garanziaApp);
                }
            }
            this._Polizze.Polizze.push(polizzaApp);
        }
        this._CalcolaPolizze++;
    }

    private OnCreateAddendum(dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            const url = (this.props.match.params as any).ID_Anag ? `/anagrafica/${this.ID_AnagContraente}/RCPPolizza/${this.ID_Polizza}/RCPAppendice` : `/RCPPolizza/${this.ID_Polizza}/RCPAppendice`;

            Glob.InfoModaleSuccess(Trad.Trad("Addendum").toUpperCase(), Trad.Trad("AppendiceInseritaCorrettamente"));
            this.props.history.replace(`${url}/${dati.ID_Chiave}`);
        }
    }

    public render() {
        this.ID_Polizza = (this.props.match.params as any).ID_Polizza || 0;
        this.ID_AnagContraente = this.state.Dati.Dato.ID_AnagContraente || (this.props.match.params as any).ID_Anag || 0;
        this.ID_Appendice = (this.props.match.params as any).ID_Appendice || 0;

        const productTypeId = this.state.Dati.Dato.ID_TipoProdotto;
        const isFormDisabled = this.ID_Appendice > 0;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-sticky-note" />
                        </span>
                        <h3 className="kt-portlet__head-label">{Trad.Trad("Addendum")}</h3>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--label-align-left- kt-form login-form--state-" id="kt_form" noValidate>
                    <div className="kt-portlet__body">
                        <div className="row">
                            <div className="col-xl-10 offset-xl-1">
                                <div className="kt-form login-form__section kt-form login-form__section--first">
                                    <div className="kt-form login-form__heading">
                                        <h3 className="kt-form login-form__heading-title">{Trad.Trad("Information")}</h3>
                                    </div>
                                    <div className="form-group kt-form login-form__group row">
                                        <div className="col-lg-4 kt-form login-form__group-sub">
                                            <label className="form-control-label">{Trad.Trad("Professione")}</label>
                                            <input value={Trad.Trad(this.state.Dati.Dato.TipoProdotto)} className="form-control kt-input" name="Dati.Dato.ID_TipoProdotto" disabled />
                                        </div>
                                    </div>
                                    <CampiPolizza
                                        Gruppo="Livello1"
                                        Riga={1}
                                        Info={this.state.Dati.Info}
                                        DatoPolizza={this.state.DatoRCPPolizza}
                                        Identificatore="DatoRCPPolizza"
                                        Limiti={{}}
                                        OnChange={(e, v, changedFields) => {
                                            const { value, label, fieldTypeId } = this.GetFieldDetails(e, v);
                                            const elementGroup = changedFields ? [changedFields] : [];

                                            this.OnChange(e, v);
                                            this.OnChangeElement(e, value, label, fieldTypeId, elementGroup);
                                        }}
                                        OnChangeDeroga={() => {}}
                                        OnBlur={() => {}}
                                        DimensioneGrafica={3}
                                        Abilitato={!isFormDisabled}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="accordion accordion-solid accordion-toggle-plus" id="kt_accordion_1" role="tablist">
                            <div className="card">
                                <AccordionGaranzie
                                    Name="GaranzieJSON"
                                    Id="GaranzieJSON"
                                    Value={this.state.GaranzieJSON}
                                    OnChange={this.OnChangeGaranzia}
                                    OnChangeElement={this.OnChangeGaranziaElement}
                                    Abilitato={!isFormDisabled}
                                    Indice={1}
                                />
                            </div>
                            <div className="card">
                                <AccordionProdotti
                                    ShowOnlySelected
                                    Id="PolizzeJSON"
                                    Name="PolizzeJSON"
                                    OnChange={this.OnChange}
                                    OnChangeAppendice={this.OnChangeElement}
                                    Value={this.state.PolizzeJSON}
                                    Abilitato={!isFormDisabled}
                                    CampoPreventivoSelezionato="PreventivoSelezionato"
                                    Indice={2}
                                    Forzabili={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore}
                                />
                            </div>
                            <div className="card">
                                <AccordionCampiPolizza
                                    Gruppo="Livello3"
                                    Riga={3}
                                    Info={this.state.Dati.Info}
                                    DatoPolizza={this.state.DatoRCPPolizza}
                                    Identificatore="DatoRCPPolizza"
                                    Limiti={{}}
                                    OnChange={(e, v) => {
                                        const { value, label, fieldTypeId, elementGroup } = this.GetFieldDetails(e, v);
                                        this.OnChange(e, v);
                                        this.OnChangeElement(e, value, label, fieldTypeId, elementGroup);
                                    }}
                                    OnChangeDeroga={() => {}}
                                    OnBlur={() => {}}
                                    DimensioneGrafica={6}
                                    Abilitato={!isFormDisabled}
                                    Indice={3}
                                />
                            </div>
                            <div className="card overflow-visible">
                                <AccordionAnagrafica
                                    AnagraficaJSON={this.state.AnagraficaJSON}
                                    AnagraficaId="AnagraficaJSON"
                                    AnagraficaName="AnagraficaJSON"
                                    DatiProfessionaliJSON={this.state.DatiProfessionaliJSON}
                                    DatiProfessionaliId="DatiProfessionaliJSON"
                                    DatiProfessionaliName="DatiProfessionaliJSON"
                                    IndirizziJSON={this.state.IndirizziJSON}
                                    IndirizziId="IndirizziJSON"
                                    IndirizziName="IndirizziJSON"
                                    RecapitiJSON={this.state.RecapitiJSON}
                                    RecapitiId="RecapitiJSON"
                                    RecapitiName="RecapitiJSON"
                                    OnChange={this.OnChange}
                                    OnChangeAppendice={this.OnChangeElement}
                                    Indice={4}
                                    Id="Anagrafica"
                                    Name="Anagrafica"
                                    CampoTipo="Dato.ID_AnagContraente"
                                    ID_AnagContraente={this.ID_AnagContraente}
                                    ID_TipoProdotto={this.state.Dati.Dato.ID_TipoProdotto}
                                    CampoIDAnagrafica="Dati.Dato.ID_AnagContraente"
                                    ID_TipoAnagPrincipale="DatiAnagrafica.ID_TipoAnagPrincipale"
                                    StatoAnagrafica={Glob.Tipi_AS_Attivo}
                                />
                            </div>
                            <div className="card overflow-visible">
                                <div className="card-header">
                                    <a href="#kt_accordion_1_item_5_body" className="card-title collapsed" role="tab" id="kt_accordion_1_item_5_head" data-toggle="collapse" aria-expanded="false">
                                        <span className="accordion__item-icon">
                                            <i className="fa fa-feather-alt"></i>
                                        </span>
                                        <span className="accordion__item-icon">{Trad.Trad("DatiEmissione")}</span>
                                        <span className="kt-accordion__item-mode" />
                                    </a>
                                    <div
                                        className="kt-accordion__itekt-body collapse spazioVerticale"
                                        id="kt_accordion_1_item_5_body"
                                        role="tabpanel"
                                        aria-labelledby="kt_accordion_1_item_5_head"
                                        data-parent="#kt_accordion_1"
                                    >
                                        <div className="tab-content kt--padding-30">
                                            <div className="form-group special-group kt-form login-form__group row">
                                                <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                    <InputData
                                                        ValoreInArrivo
                                                        Name="Dato.DataEffetto"
                                                        Id="Dato.DataEffetto"
                                                        Valore={this.state.Dati.Dato.DataEffetto}
                                                        OnChange={(e, v) => {
                                                            this.OnChange(e, v);
                                                            this.OnChangeElement(e, v, "DataEffetto", 3);
                                                        }}
                                                        Etichetta="DataEffetto"
                                                    />
                                                </div>
                                                <div className={`${Glob.DimensioneCSS(4)} kt-form login-form__group-sub`}>
                                                    <InputData
                                                        ValoreInArrivo
                                                        Name="Dato.DataFine"
                                                        Id="Dato.DataFine"
                                                        Valore={this.state.Dati.Dato.DataFine}
                                                        OnChange={(e, v) => {
                                                            this.OnChange(e, v);
                                                            this.OnChangeElement(e, v, "DataScadenza", 3);
                                                        }}
                                                        Etichetta="DataScadenza"
                                                    />
                                                </div>
                                                <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                    <label>{Trad.Trad("Frazionamento")}</label>
                                                    <Tipo
                                                        Campo="Frazionamento"
                                                        ID_ChiaveString={this.state.Frazionamento.toString() || ""}
                                                        OnAggiorna={(e, v) => {
                                                            this.OnChange(e, v);
                                                            this.OnChangeElement(e, v, "Frazionamento", 7);
                                                        }}
                                                        Dati={this._Frazionamento}
                                                        Disabilitato={isFormDisabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--left">
                                    <AddendumActions
                                        Disabled={isFormDisabled}
                                        FormData={this.state.FormData}
                                        Policy={this.state.Dati.Dato.Polizza}
                                        PolicyId={this.ID_Polizza}
                                        OnCreateAddendum={this.OnCreateAddendum}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ChiamaAPI
                        Aggiornare={this.ID_AnagContraente}
                        URL={"/api/anag/seleziona?id_Anag=" + this.ID_AnagContraente}
                        OnRis={(s, d, dn) => this.OnRisAnagrafica(s, d, dn)}
                        OnErrore={this.OnErrore}
                    />
                    <ChiamaAPI
                        Aggiornare={productTypeId}
                        URL={`/api/Polizza/GetInfoPolizza?ID_TipoProdotto=${productTypeId}`}
                        OnRis={(s, d, dn) => this.OnRisDatiPolizzaNuova(s, d, dn)}
                        OnErrore={this.OnErrore}
                    />
                    <ChiamaAPI
                        Aggiornare={1}
                        URL={`/api/Polizza/?id_Polizza=${this.ID_Polizza}&id_AnagContraente=${this.ID_AnagContraente}`}
                        OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                        OnErrore={this.OnErrore}
                    />
                    <ChiamaAPI
                        Aggiornare={this._CalcolaPolizze}
                        URL={"/api/Polizza/CalcolaPreventiviRCP"}
                        OnInvio={s => this.OnInvioCalcola(s)}
                        OnRis={(s, d, dn) => this.OnRisCalcolaPolizze(s, d, dn)}
                        OnErrore={this.OnErrore}
                    />
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/RCPAppendice.tsx